"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerPubKey = exports.decryptRes = exports.encryptReq = exports.attachEphPubKey = exports.decrypt = exports.encrypt = exports.generateClientKey = exports.calculateSharedKey = void 0;
const axios_1 = __importDefault(require("axios"));
const async_await_mutex_lock_1 = require("async-await-mutex-lock");
const base64_js_1 = __importDefault(require("base64-js"));
const js_crypto_ec_1 = require("js-crypto-ec");
const js_crypto_key_utils_1 = __importDefault(require("js-crypto-key-utils"));
const js_crypto_random_1 = require("js-crypto-random");
const js_crypto_aes_1 = __importDefault(require("js-crypto-aes"));
const elliptic_1 = require("elliptic");
const crypto_js_1 = __importDefault(require("crypto-js"));
const ecP521 = new elliptic_1.ec("p521");
const ecP256 = new elliptic_1.ec("p256");
const logLabel = "[payloadencryption]";
const encryptionKeyLabel = "x-encryption-key";
const serverKeySaveMinInterval = 20000;
const dec = new TextDecoder();
const enc = new TextEncoder();
function getEphPubB64(clientKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const keyObj = new js_crypto_key_utils_1.default.Key("jwk", clientKey.publicKey);
        const ephPub = yield keyObj.export("der");
        const base64 = base64_js_1.default.fromByteArray(ephPub);
        return base64;
    });
}
function calculateSharedKey(keys) {
    return __awaiter(this, void 0, void 0, function* () {
        let clientPair;
        let remotePub;
        let client = undefined;
        const pubx = Buffer.from(keys.serverKey.x, "base64").toString("hex");
        const puby = Buffer.from(keys.serverKey.y, "base64").toString("hex");
        if (keys.clientKey.privateKey.d) {
            client = Buffer.from(keys.clientKey.privateKey.d, "base64").toString("hex");
        }
        if (!client) {
            throw new Error("Client private key not found.");
        }
        if (keys.serverKey.crv == "P-521") {
            clientPair = ecP521.keyFromPrivate(client, "hex");
            remotePub = ecP521.keyFromPublic({
                x: pubx,
                y: puby,
            }, "hex");
        }
        else if (keys.serverKey.crv == "P-256") {
            clientPair = ecP256.keyFromPrivate(client, "hex");
            remotePub = ecP256.keyFromPublic({
                x: pubx,
                y: puby,
            }, "hex");
        }
        let sharedKey = undefined;
        if (clientPair && remotePub) {
            const sharedRaw = clientPair.derive(remotePub.getPublic());
            const sharedRawWordArr = crypto_js_1.default.enc.Hex.parse(toHexString(sharedRaw.toArray()));
            const shared = crypto_js_1.default.SHA256(sharedRawWordArr).toString();
            sharedKey = Buffer.from(shared, "hex").toString("base64");
        }
        if (!sharedKey) {
            throw new Error("Failed to generate shared key.");
        }
        return sharedKey;
    });
}
exports.calculateSharedKey = calculateSharedKey;
function generateClientKey(baseUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const mbaasPubJwk = yield ServerPubKey.read(baseUrl, false);
        const key = yield (0, js_crypto_ec_1.generateKey)(mbaasPubJwk.crv);
        const ephPubKey = yield getEphPubB64(key);
        return {
            serverKey: mbaasPubJwk,
            clientKey: key,
            ephPubKey,
        };
    });
}
exports.generateClientKey = generateClientKey;
function encrypt(sharedKey, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const shared = base64_js_1.default.toByteArray(sharedKey);
            const iv = (0, js_crypto_random_1.getRandomBytes)(12);
            const cipherText = yield js_crypto_aes_1.default.encrypt(enc.encode(JSON.stringify(data)), shared, {
                name: "AES-GCM",
                iv,
                tagLength: 16,
            });
            const mergedCipher = new Uint8Array(iv.length + cipherText.length);
            mergedCipher.set(iv);
            mergedCipher.set(cipherText, iv.length);
            const cipher = base64_js_1.default.fromByteArray(mergedCipher);
            return cipher;
        }
        catch (error) {
            throw error;
        }
    });
}
exports.encrypt = encrypt;
function decrypt(sharedKey, cipherText) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const shared = base64_js_1.default.toByteArray(sharedKey);
            const cipherBytes = base64_js_1.default.toByteArray(cipherText);
            const iv = cipherBytes.slice(0, 12);
            const cipher = cipherBytes.slice(12);
            const plainText = yield js_crypto_aes_1.default.decrypt(cipher, shared, {
                name: "AES-GCM",
                iv,
                tagLength: 16,
            });
            return dec.decode(plainText);
        }
        catch (error) {
            throw error;
        }
    });
}
exports.decrypt = decrypt;
function attachEphPubKey(req, keys) {
    if (req.headers)
        req.headers[encryptionKeyLabel] = keys.ephPubKey;
    return req;
}
exports.attachEphPubKey = attachEphPubKey;
function encryptReq(req, keys) {
    return __awaiter(this, void 0, void 0, function* () {
        let sharedKey;
        try {
            sharedKey = yield calculateSharedKey(keys);
        }
        catch (error) {
            console.warn(logLabel, error);
            return req;
        }
        if (req.headers)
            req.headers[encryptionKeyLabel] = keys.ephPubKey;
        const cipher = yield encrypt(sharedKey, req.data);
        req.data = JSON.stringify({ cipherText: cipher });
        return req;
    });
}
exports.encryptReq = encryptReq;
function decryptRes(res, keys, baseUrl, retrial) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!res.data)
            return res;
        let sharedKey;
        try {
            sharedKey = yield calculateSharedKey(keys);
        }
        catch (error) {
            console.warn(logLabel, error);
            return res;
        }
        try {
            const plainText = yield decrypt(sharedKey, res.data.cipherText);
            res.data = JSON.parse(plainText);
        }
        catch (err) {
            if (retrial) {
                console.warn(logLabel, err);
                return res;
            }
            keys.serverKey = yield ServerPubKey.read(baseUrl, true);
            return decryptRes(res, keys, baseUrl, true);
        }
        return res;
    });
}
exports.decryptRes = decryptRes;
class ServerPubKey {
    static read(baseUrl, refetch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ServerPubKey.lock.acquire(1);
            const interval = Date.now() - ServerPubKey.lastSave;
            if (ServerPubKey.pubKey === null ||
                (refetch && interval >= serverKeySaveMinInterval)) {
                yield ServerPubKey.fetch(baseUrl);
            }
            ServerPubKey.lock.release(1);
            return ServerPubKey.pubKey;
        });
    }
    static fetch(baseUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield axios_1.default.get(`${baseUrl}/.encryption/jwks.json`);
            ServerPubKey.pubKey = res.data.keys[0];
            ServerPubKey.lastSave = Date.now();
        });
    }
}
exports.ServerPubKey = ServerPubKey;
ServerPubKey.lock = new async_await_mutex_lock_1.Lock();
ServerPubKey.pubKey = null;
ServerPubKey.lastSave = 0;
function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
        return ("0" + (byte & 0xff).toString(16)).slice(-2);
    }).join("");
}
